import React, { useState, useEffect } from 'react';
import EducationalFullContent from './EducationalFullContent';
import api from '../../services/api';
import './EducationalBlock.css';

const EducationalBlock = ({ onOpenFullContent, isFullScreenMode, onClose }) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState({});

  const handleImageError = (id) => {
    setImages(prev => ({ ...prev, [id]: false }));
  };

  const handleOpenFullContent = () => {
    if (onOpenFullContent) {
      onOpenFullContent(news);
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      try {
        const data = await api.getNews(null, 4);
        const activeNews = data.filter(item => item.is_active === 1);
        setNews(activeNews);
        // Инициализируем images для каждой новости как true (есть фото)
        const initialImages = {};
        activeNews.forEach(item => {
          initialImages[item.id] = true;
        });
        setImages(initialImages);
      } catch (error) {
        console.error('Ошибка загрузки новостей:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  const truncateText = (text, maxLength = 60) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const getContentType = (item) => {
    if (item.video_url) return 'video';
    return 'image';
  };

  const getCategoryIcon = (item) => {
    if (item.video_url) return '🎬';
    if (item.category === 'promo') return '🎁';
    return '📰';
  };

  const renderImage = (item) => {
    const imageUrl = item.image_url && item.image_url !== '' ? item.image_url : null;
    const isVideo = getContentType(item) === 'video';
    
    // Если есть ошибка загрузки или нет фото - показываем заглушку
    if (images[item.id] === false || !imageUrl) {
      return (
        <div className="card-image-container placeholder-image">
          <div style={{ textAlign: 'center' }}>
            <span style={{ fontSize: '40px', display: 'block' }}>📷</span>
            <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.5)' }}>Нет фото</span>
          </div>
        </div>
      );
    }

    return (
      <div 
        className={isVideo ? 'video-container' : 'card-image-container'}
        style={{ '--bg-image': `url(${imageUrl})` }}
      >
        <img 
          src={imageUrl}
          alt={item.title}
          className="card-image"
          loading="lazy"
          onError={() => handleImageError(item.id)}
        />
        {isVideo && <div className="play-icon">▶</div>}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="educational-block">
        <div className="educational-header">
          <h3 className="educational-title">Образовательный блок</h3>
        </div>
        <div className="loading-spinner" style={{ textAlign: 'center', padding: '20px', color: 'white' }}>
          Загрузка...
        </div>
      </div>
    );
  }

  if (isFullScreenMode) {
    return (
      <div className="educational-fullscreen">
        <EducationalFullContent 
          onClose={handleClose} 
          initialNews={news}
        />
      </div>
    );
  }

  return (
    <div className="educational-block">
      <div className="educational-header">
        <h3 className="educational-title">Образовательный блок</h3>
      </div>

      <div className="educational-grid">
        {news.map(item => (
          <div 
            key={item.id} 
            className="educational-card"
            onClick={() => {
              if (onOpenFullContent) {
                onOpenFullContent(news);
              }
            }}
          >
            {renderImage(item)}
            <div className="card-content">
              <div className="card-title">
                <span style={{ marginRight: '5px' }}>{getCategoryIcon(item)}</span>
                {item.title}
              </div>
              <div className="card-description" title={item.description || item.content}>
                {truncateText(item.description || item.content, 50)}
              </div>
            </div>
          </div>
        ))}
      </div>

      {news.length > 0 && (
        <button className="educational-more-btn" onClick={handleOpenFullContent}>
          <span className="more-btn-text">Подробнее</span>
          <span className="more-btn-icon">→</span>
        </button>
      )}
    </div>
  );
};

export default EducationalBlock;